import React from 'react';
import PropTypes from 'prop-types';
import './styles/style.scss';

const Li = props => <p className="c-vi-li">{props.children}</p>;

Li.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Li;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/visualIdentity/Li.jsx